import React from 'react'
import { IconProps } from 'types/common'

/** 2x2 rounded-square grid — Discover nav icon */
const DiscoverIcon: React.FC<Partial<IconProps>> = ({
  width = 22,
  height = 22,
  stroke = 'currentColor',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="3" y="3" width="7.5" height="7.5" rx="2.25" stroke={stroke} strokeWidth="1.75" />
      <rect x="13.5" y="3" width="7.5" height="7.5" rx="2.25" stroke={stroke} strokeWidth="1.75" />
      <rect x="3" y="13.5" width="7.5" height="7.5" rx="2.25" stroke={stroke} strokeWidth="1.75" />
      <rect x="13.5" y="13.5" width="7.5" height="7.5" rx="2.25" stroke={stroke} strokeWidth="1.75" />
    </svg>
  )
}

export default DiscoverIcon
